import { Box, Flex, Img, Skeleton, Text } from "@chakra-ui/react";
import { useRouter } from "next/router";
import parse from "html-react-parser";
import React from "react";

const BlogComponent = ({ blog }) => {
  const { metaData } = blog;
  const { TAGS, FEATURE_MEDIA } = metaData;

  const router = useRouter();
  const jsDate = new Date(blog.date);
  const month = jsDate.toLocaleString("default", { month: "long" });

  const TagComponent = ({ tag }) => (
    <Box
      height={"30px"}
      borderRadius={"15px"}
      bg="golden"
      alignItems={"center"}
      justifyContent={"center"}
      py={"3px"}
      px={"10px"}
      mr={"3px"}
      mb={"3px"}
      _hover={{ cursor: "pointer" }}
      onClick={() => router.push(`/blogs/tag/${tag.slug}`)}
    >
      <Text
        fontWeight="normal"
        fontSize="14px"
        color={"white"}
        textAlign={"center"}
        marginTop={"auto"}
        marginBottom={"auto"}
      >
        {tag.name}
      </Text>
    </Box>
  );

  return (
    <>
      <Flex
        mb="30px"
        shadow="lg"
        flexWrap="wrap"
        maxWidth="400px"
        borderWidth="0px"
        overflow="hidden"
        borderRadius="5px"
        alignItems="center"
        height="fit-content"
        justifyContent="center"
        width={{
          base: "90%",
          md: "340px",
          lg: "400px",
          xl: "340px",
          "2xl": "400px",
        }}
      >
        <Box
          position="relative"
          width="100%"
          height="100%"
          maxHeight="250px"
          overflow="hidden"
          _hover={{ cursor: "pointer" }}
          onClick={() => router.push(`/blogs/${blog.slug}`)}
        >
          <Img
            lazy="true"
            width="100%"
            height="100%"
            maxHeight="250px"
            src={
              FEATURE_MEDIA && FEATURE_MEDIA.sourceUrl
                ? FEATURE_MEDIA.sourceUrl
                : "https://via.placeholder.com/600?text=Dr.Vasishth%27s+AyuRemedies"
            }
            alt={"blog-image"}
            objectFit="contain"
            fallback={<Skeleton w="100%" height="100%" />}
          />
        </Box>
        <Flex width="100%" flexDirection="column" padding="10px">
          <Text
            color={"maroon"}
            variant="productCardTitle"
            noOfLines={1}
            _hover={{ cursor: "pointer" }}
            onClick={() => router.push(`/blogs/${blog.slug}`)}
          >
            {parse(blog.title.rendered)}
          </Text>
          <Text
            my="5px"
            noOfLines={2}
            flexWrap="wrap"
            fontWeight="400"
            fontSize="16px"
            fontFamily="Lato"
            color="detailsColor"
          >
            {parse(blog.excerpt.rendered)}
          </Text>

          {TAGS && TAGS.length > 0 && (
            <Flex my={3} mb={2} flexWrap="wrap">
              {TAGS.map((tag) => (
                <TagComponent tag={tag} />
              ))}
            </Flex>
          )}

          <Text
            mt={3}
            flexWrap="wrap"
            fontWeight="400"
            fontSize="12px"
            fontFamily="Lato"
            color="titleColor"
          >
            {`${month} ${jsDate.getDate()}, ${jsDate.getFullYear()}`}
          </Text>
        </Flex>
      </Flex>
    </>
  );
};

export default BlogComponent;
